export function filterKeyEnter(handler) {
  return (e) => {
    if (e.keyCode === 13) {
      handler(e);
    }
  };
}

export function accessibleOnClick(handler, tabIndex = 0) {
  return {
    role: 'button',
    tabIndex,
    onKeyDown: (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handler(e);
      }
    },
    onClick: (e) => {
      // Garante que Tab nunca dispare ação
      if (e.detail === 0) return;
      handler(e);
    },
  };
}
